import { Link, Outlet } from 'react-router'
import { SiteNavbar } from '#app/components/site-navbar.tsx'

export default function MarketingLayout() {
	return (
		<div className="flex min-h-screen flex-col">
			<SiteNavbar />

			<div className="flex-1">
				<Outlet />
			</div>

			<footer className="container flex items-center justify-between pb-5">
				<Logo />
			</footer>
		</div>
	)
}

function Logo() {
	return (
		<Link to="/" className="group flex items-center gap-1 leading-snug">
			<span className="text-lg font-bold tracking-tight transition group-hover:opacity-80">
				Matematix
			</span>
		</Link>
	)
}
